export { default } from './FullBleedMedia'
